export var userConstants = {
    PROFILE_REQUEST: 'USER_PROFILE_REQUEST',
    PROFILE_SUCCESS: 'USER_PROFILE_SUCCESS',
    PROFILE_FAILURE: 'USER_PROFILE_FAILURE',
    PROFILE_UPDATE: 'USER_PROFILE_UPDATE',
    PROFILE_ERASE: 'USER_PROFILE_ERASE',
};
